import React from 'react'
import axios from 'axios';
import { useEffect } from 'react';
function BlankPage() {
  // axios.get('http://localhost:8080/usersWithImages', {
  //   params: {
  //     appId: 3,
  //   }
  // })
  // .then(response => {
  //   // Handle the response
  //   console.log("userswith images fetched");
  // })
  // .catch(error => {
  //   // Handle errors
  //   console.log(error);
  // });
  return (
    <div>BlankPage</div>
  )
}

export default BlankPage
